import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
    if (!isOpen) return null;

    const sizes = {
        sm: 'max-w-md',
        md: 'max-w-lg',
        lg: 'max-w-2xl',
        xl: 'max-w-4xl',
        '2xl': 'max-w-5xl',
        '3xl': 'max-w-6xl',
        '4xl': 'max-w-7xl',
        full: 'max-w-[95vw]'
    };

    const modalContent = (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 overflow-hidden">
            {/* Backdrop with fade-in */}
            <div
                className="fixed inset-0 bg-slate-900/70 transition-opacity"
                onClick={onClose}
            ></div>

            {/* Modal Container with scale-in */}
            <div 
                className={`relative z-[101] bg-white dark:bg-[#002147] rounded-[2rem] shadow-2xl flex flex-col w-full ${sizes[size]} max-h-[90vh] overflow-hidden border border-slate-200/80 dark:border-[#1a3884]/30 animate-fade-in`}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-8 py-5 border-b border-slate-100 dark:border-[#1a3884]/30 flex-shrink-0 bg-white dark:bg-[#002147]">
                    <h3 className="text-[1.75rem] font-display font-semibold text-slate-900 dark:text-white tracking-tight leading-none">{title}</h3>
                    <button
                        onClick={onClose}
                        className="p-2 text-slate-400 hover:text-[#4f7dff] hover:bg-slate-100 dark:hover:bg-[#1a3884]/20 rounded-xl transition-all"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="px-8 py-7 overflow-y-auto custom-scrollbar flex-1 bg-white dark:bg-[#002147]">
                    {children}
                </div>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default Modal;
